import request from "../utils/request";
import setting from "./apiSetting";
var type = "List";
var urls = 'http://' + setting.getip() + ":" + setting.getport() + "/api/" + type;
var myfunction = {
  //获取设备类别列表
  getDeviceCategory: function getDeviceCategory(data) {
    return request({
      url: urls + "/DeviceCategory",
      method: 'get',
      params: data
    });
  },
  //获取保养类别列表
  getMaintainType: function getMaintainType(data) {
    return request({
      url: urls + "/MaintainType",
      method: 'get',
      params: data
    });
  },
  //获取维修级别列表
  getRepairLevel: function getRepairLevel(data) {
    return request({
      url: urls + "/RepairLevel",
      method: 'get',
      params: data
    });
  },
  //获取维修类别列表
  getRepairType: function getRepairType(data) {
    return request({
      url: urls + "/RepairType",
      method: 'get',
      params: data
    });
  },
  //获取列表
  getType: function getType(listType) {
    return request({
      url: urls + "/" + listType,
      method: 'get'
    });
  },
  //添加或删除列表
  editType: function editType(data, listType) {
    return request({
      url: urls + "/" + listType,
      method: 'post',
      data: data
    });
  }
};
export default myfunction;